import React, { useEffect, useRef } from "react";
import ECGIcon from "../../assets/img/ecg_new.gif";

const ECG_HEIGHT = 240;

const EcgScrollImage = ({ src }) => {
    const containerRef = useRef(null);
    const trackRef = useRef(null);
    const imgRef = useRef(null);
    const rafRef = useRef(null);
    const posRef = useRef(0);

    useEffect(() => {
        if (!src) return;

        const img = imgRef.current;
        const track = trackRef.current;

        if (!img || !track) return;

        let imgW = 0;

        const animate = () => {
            if (!imgW) return;
            posRef.current -= 1; 
            if (posRef.current <= -imgW) {
                posRef.current = 0;
            }
            track.style.transform = `translateX(${posRef.current}px)`;
            rafRef.current = requestAnimationFrame(animate);
        };

        const startAnimation = () => {
            imgW = img.offsetWidth;
            if (!imgW) {
                setTimeout(startAnimation, 50);
                return;
            }
            cancelAnimationFrame(rafRef.current);
            posRef.current = 0;
            rafRef.current = requestAnimationFrame(animate);
        };

        if (img.complete && img.naturalWidth > 0) {
            startAnimation();
        } else {
            img.onload = startAnimation;
        }

        return () => {
            cancelAnimationFrame(rafRef.current);
            if (img) img.onload = null;
        };
    }, [src]);

    if (!src) {
        return (
            <div style={{
                width: "100%",
                height: `${ECG_HEIGHT}px`,
                overflow: "hidden",
                backgroundColor: "#fff",
            }}>
                <img
                    src={ECGIcon}
                    alt="ECG"
                    style={{ width: "100%", height: "100%", objectFit: "fill" }}
                />
            </div>
        );
    }

    return (
        <div
            ref={containerRef}
            style={{
                width: "100%",
                height: `${ECG_HEIGHT}px`,
                overflow: "hidden",
                backgroundColor: "#fff",
                position: "relative",
            }}
        >
            <div
                ref={trackRef}
                style={{
                    display: "flex",
                    flexShrink: 0,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    willChange: "transform",
                }}
            >
                <img
                    ref={imgRef}
                    src={src}
                    alt="ECG Report"
                    style={{
                        height: `${ECG_HEIGHT}px`,
                        width: "auto",
                        display: "block",
                        flexShrink: 0,
                    }}
                />
                <img
                    src={src}
                    alt=""
                    aria-hidden="true"
                    style={{
                        height: `${ECG_HEIGHT}px`,
                        width: "auto",
                        display: "block",
                        flexShrink: 0,
                    }}
                />
            </div>
        </div>
    );
};

export default EcgScrollImage;